import { useEffect } from "react"

export function ErrorComponent(props) {
    useEffect(() => {
        window.history.back();
    }, [])
    return (<div></div>)
}